import React from "react";

import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { PDPAvailabilityNotificationsTranslationsProps } from "./types";
import { PDPAvailabilityNotificationActive } from "./PDPAvailabilityNotificationActive";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { PDPAvailabilityNotificationState } from "./state";

export const PDPAvailabilityNotification: ReactTFC<{
  locale: SwarovskiOptikLocaleFrontend;
  translations: PDPAvailabilityNotificationsTranslationsProps;
  privacyPolicyLink: string;
  screen: PDPAvailabilityNotificationState;
  hideModalCallback: () => void;
}> = props => {
  if (props.screen.tag === "impossible" || props.screen.tag === "disabled") {
    return null;
  }

  return (
    <PDPAvailabilityNotificationActive
      translations={props.translations}
      locale={props.locale}
      privacyPolicyLink={props.privacyPolicyLink}
      screen={props.screen}
      hideModalCallback={props.hideModalCallback}
    />
  );
};
